module.exports = __webpack_public_path__ + "static/logo-black-7abdc7a33210c3852c3b344001502b14.png";